<template>
  <div :class="$attrs.class">
    <div class="catering--flex-row-wrapper tw-overflow-hidden 2xl:tw-rounded-3xl 2xl:tw-shadow-lg tw-bg-white tw-block tw-group tw-w-full tw-items-center tw-py-4 2xl:tw-py-0'">
      <div class="tw-overflow-hidden tw-block 2xl:tw-h-auto tw-w-40 2xl:tw-w-full tw-relative tw-grow-0 tw-shrink-0">
        <div class="tw-absolute tw-top-0 tw-bottom-0 tw-left-0 tw-right-0 tw-flex tw-items-center tw-justify-center tw-z-10" v-if="isLoading">
            <span class="fa fa-spinner tw-text-black tw-inline-block tw-animate-spin tw-ease tw-duration-300 tw-text-5xl"></span>
        </div>
        <img 
          :alt="suggestion.title+' image'"
          :class="['tw-scale-105 2xl:tw-h-full tw-w-full tw-transition-all tw-duration-300 tw-ease-out', {'tw-opacity-40': isLoading}]"
          :src="productImage">
      </div>
      
      <div :class="['tw-px-8 2xl:tw-pt-8 2xl:tw-text-center tw-font-black tw-w-full tw-block', {'tw-text-gray-400': isLoading}]">
        <div class="tw-mb-4 2xl:tw-mb-4">
          {{suggestion.title}}
        </div>
        <div :class="['2xl:tw-text-center tw-font-normal tw-w-full tw-block tw-text-xl']">
          <div class="tw-mb-6 2xl:tw-mb-8 tw-cursor-pointer tw-underline hover:tw-text-orange-medium" @click="handleDetails">More Details</div>
        </div>

        <TwButton
          cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white tw-text-lg 2xl:tw-text-2xl hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-8 2xl:tw-px-12 tw-py-2 2xl:tw-py-3 tw-transition-all tw-duration-200 tw-rounded-full tw-mb-4"
          @click="handleAdd"
          :isLoading="isLoading"
          :buttonText="addToBagText" />
        </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted, computed } from 'vue'
  import type CateringOrderSuggestion from '../../classes/CateringOrderSuggestion';
  import type Product from '../../classes/Product';
  import TwButton from '../../components/TwButton.vue';

  const props = defineProps<{ suggestion: CateringOrderSuggestion, index: number, isLoading: boolean, isDisabled: boolean }>();

  const productImage = ref('https://mypiada-assets.s3.amazonaws.com/static_assets/scooter-placeholder.jpg');

  const emit = defineEmits(['handleSuggestedOrderClick', 'handleSuggestedOrderModal'])

  const handleAdd = (event: Event) => {
    if (!props.isDisabled) {
      emit('handleSuggestedOrderClick', props.index)
    }
  }

  const handleDetails = (event: Event) => {
    emit('handleSuggestedOrderModal', props.index)
  }

  const addToBagText = computed(() => {
    let str = 'Add to Bag - $';
    if (props.suggestion && props.suggestion.cost) {
      str += props.suggestion.cost!.toLocaleString("en-US", {minimumFractionDigits: 2})
    } else {
      str += '0.00'
    }

    return str;
  })

  // const suggestionDescription = computed(() => {
  //   let str = "";

  //   if (props.suggestion && props.suggestion.description) {
  //     str += props.suggestion.description;

  //     if (props.suggestion.products && props.suggestion.products.length > 0) {
  //       props.suggestion.products.forEach((product: Product, index: number) => {
  //         if (product.quantity > 1) {
  //           str += product.quantity + 'x ';
  //         }

  //         str += product.name;

  //         if (index < props.suggestion.products!.length - 1) {
  //           str += ", "
  //         }
  //       })
  //     }
  //   }

  //   return str;
  // })
</script>

<style scoped>
  .catering--flex-row-wrapper {
    display: flex;
    align-items: center;
  }

  @media screen and (min-width: 1536px) {
    .catering--flex-row-wrapper {
      display: block;
    }
  }
</style>
